import React, { Component } from 'react'
import classNames from 'classnames'

import { UP_KEY, DOWN_KEY, ENTER_KEY, TAB_KEY } from '../../config/keyCodes'

import HighlightedText from '../HighlightedText'

export default class DropDown extends Component {
  state = {
    selected: 0,
    scrollPos: 0,
    optionElementHeight: 0,
  }

  listElementRef = React.createRef()

  componentDidMount() {
    document.addEventListener('keydown', event => this._onKeyDown(event))
  }

  componentDidUpdate() {
    if (this.state.selected > this.props.options.length) {
      this.setState({ selected: 0 })
    }

    if (this.state.optionElementHeight === 0) {
      this._updateOptionElementHeight()
    }
  }

  // @Improvement: Cleanup the amount of code needed for the height value
  _updateOptionElementHeight() {
    if (!this.props.options.length) return

    const ref = this.props.options[0].ref.current || {
      getBoundingClientRect: () => ({
        height: 0,
      }),
    }

    const height = ref.getBoundingClientRect().height
    if (height > 0) {
      this.setState({
        optionElementHeight: height,
      })
    }
  }

  _onClick() {
    this._conformSelection()
  }

  _onKeyDown(event) {
    if (!this.props.active) return

    switch (event.keyCode) {
      case UP_KEY:
        this._moveUp()
        break

      case DOWN_KEY:
        this._moveDown()
        break

      case ENTER_KEY:
        event.preventDefault()
        this._conformSelection()
        break

      case TAB_KEY:
        this._conformSelection()
        break
      default:
        break
    }
  }

  _updateScrollPos(newPos) {
    this.setState({ scrollPos: newPos })

    const current = this.listElementRef.current || { scrollTop: 0 }
    current.scrollTop = this.state.scrollPos
  }

  // @Improvement: Cleanup multiple turnery statements
  _moveUp() {
    const reachedTop = this.state.selected === 0

    const newSelected = reachedTop ? 0 : this.state.selected - 1
    const newScrollPos = reachedTop
      ? this.state.scrollPos
      : this.state.scrollPos - this.state.optionElementHeight

    this._setNewSelected(newSelected)
    this._updateScrollPos(newScrollPos)
  }

  // @Improvement: Cleanup multiple turnery statements
  _moveDown() {
    const canMoveDown = this.state.selected < this.props.options.length - 1

    const newSelected = canMoveDown
      ? this.state.selected + 1
      : this.state.selected
    const newScrollPos = canMoveDown
      ? this.state.scrollPos + this.state.optionElementHeight
      : this.state.scrollPos

    this._setNewSelected(newSelected)
    this._updateScrollPos(newScrollPos)
  }

  _conformSelection() {
    const selectedOption = this.props.options[this.state.selected]
    const id = selectedOption ? selectedOption.id : ''

    this.props.onValueChange(id)
  }

  _setNewSelected(index) {
    this.setState({ selected: index })
  }

  render() {
    const { options, inputValue, classes } = this.props
    if (!options.length) return false

    const cssClasses = classNames(classes['drop-down'], {
      [classes['hidden']]: !this.props.active,
    })

    return (
      <div className={cssClasses}>
        <ol className={classes['list']} ref={this.listElementRef}>
          {options.map((option, index) => (
            <li
              ref={option.ref}
              key={option.name}
              className={classes['list-item']}
              data-value={option.id}
              data-active={index === this.state.selected}
              onMouseDown={() => this._onClick()}
              onMouseEnter={() => this._setNewSelected(index)}
            >
              <HighlightedText text={option.name} inputValue={inputValue} />
            </li>
          ))}
        </ol>
      </div>
    )
  }
}
